// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"14":"bd82a186","106":"145d34f0"}[chunkId] + ".chunk.css";
};